<template>
  <div class="w-50">
    <table class="w-100">
      <tr>
        <td colspan="2" class="bg-kplh-sub text-white">
          PENGESAHAN OLEH TIM PENILAI
        </td>
      </tr>
      <!-- /**
      *-----------------------------------------------------------------------------
      * HSE
      *-----------------------------------------------------------------------------
      */ -->
      <tr>
        <td class="col-4 text-center bg-kplh-third">Tanggal penilaian</td>
        <td class="col-8">
          {{
            formatDate(
              kplh && $get(kplh, 'request.kplh_penilaian.hse_submit_date', '-')
            )
          }}
        </td>
      </tr>
      <tr>
        <td class="col-4 text-center bg-kplh-third">Nama</td>
        <td class="col-8">
          {{
            kplh && $get(kplh, 'request.kplh_penilaian.hse_detail.name', '-')
          }}
        </td>
      </tr>
      <tr>
        <td class="col-4 text-center bg-kplh-third">BU / SU</td>
        <td class="col-8">
          {{ kplh && $get(kplh, 'request.choosed_gems.nama_perusahaan', '-') }}
        </td>
      </tr>
      <tr>
        <td class="col-4 text-center bg-kplh-third">Posisi</td>
        <td class="col-8">
          {{
            kplh && $get(kplh, 'request.kplh_penilaian.hse_submit_date', '-')
              ? 'HSE'
              : 0
          }}
        </td>
      </tr>
      <tr style="height: 80px;">
        <td class="col-4 text-center bg-kplh-third">Tandatangan</td>
        <td class="col-8">{{ approved ? 'Approved' : '' }}</td>
      </tr>
      <!-- /**
      *-----------------------------------------------------------------------------
      * HEAD HSE
      *-----------------------------------------------------------------------------
      */ -->
      <tr>
        <td class="col-4 text-center bg-kplh-third">Tanggal penilaian</td>
        <td class="col-8">
          {{
            formatDate(
              kplh
                ? $get(kplh, 'request.kplh_penilaian.head_hse_submit_date', '-')
                : '-'
            )
          }}
        </td>
      </tr>
      <tr>
        <td class="col-4 text-center bg-kplh-third">Nama</td>
        <td class="col-8">
          {{
            kplh &&
              $get(kplh, 'request.kplh_penilaian.head_hse_detail.name', '-')
          }}
        </td>
      </tr>
      <tr>
        <td class="col-4 text-center bg-kplh-third">BU / SU</td>
        <td class="col-8">
          {{ kplh && $get(kplh, 'request.choosed_gems.nama_perusahaan', '-') }}
        </td>
      </tr>
      <tr>
        <td class="col-4 text-center bg-kplh-third">Posisi</td>
        <td class="col-8">
          {{
            kplh &&
            $get(kplh, 'request.kplh_penilaian.head_hse_submit_date', '-')
              ? 'Head HSE'
              : 0
          }}
        </td>
      </tr>
      <tr style="height: 80px;">
        <td class="col-4 text-center bg-kplh-third">Tandatangan</td>
        <td class="col-8">{{ approved ? 'Approved' : '' }}</td>
      </tr>
      <!-- /**
      *-----------------------------------------------------------------------------
      * KTT
      *-----------------------------------------------------------------------------
      */ -->
      <tr>
        <td class="col-4 text-center bg-kplh-third">Tanggal penilaian</td>
        <td class="col-8">
          {{
            formatDate(
              kplh
                ? $get(kplh, 'request.kplh_penilaian.ktt_submit_date', '-')
                : '-'
            )
          }}
        </td>
      </tr>
      <tr>
        <td class="col-4 text-center bg-kplh-third">Nama</td>
        <td class="col-8">
          {{
            kplh &&
              $get(
                kplh,
                'request.kplh_penilaian.ktt_detail.name',
                'no signature required'
              )
          }}
        </td>
      </tr>
      <tr>
        <td class="col-4 text-center bg-kplh-third">BU / SU</td>
        <td class="col-8">
          {{
            kplh && $get(kplh, 'request.kplh_penilaian.ktt_detail.name')
              ? $get(kplh, 'request.choosed_gems.nama_perusahaan')
              : '-'
          }}
        </td>
      </tr>
      <tr>
        <td class="col-4 text-center bg-kplh-third">Posisi</td>
        <td class="col-8">
          {{
            kplh && $get(kplh, 'request.kplh_penilaian.ktt_submit_date', '-')
              ? 'KTT HSE'
              : 0
          }}
        </td>
      </tr>
      <tr style="height: 80px;">
        <td class="col-4 text-center bg-kplh-third">Tandatangan</td>
        <td class="col-8">
          {{
            kplh && $get(kplh, 'request.kplh_penilaian.ktt_detail.name')
              ? approved
                ? 'Approved'
                : ''
              : ''
          }}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: ['kplh'],
  computed: {
    approved() {
      const status = this.$route.params.status
      const is_pdf = this.$route.path.indexOf('pdf') != -1

      if (status == 21 || is_pdf) {
        return true
      }

      return false
    },
  },
}
</script>
